import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { OtherKpDetailService } from '../../../services/other-kp-detail.service';


const apiServer = environment.apiServer;
declare var $: any;

@Component({
  selector: 'app-modal-other-kp-send-adjustment',
  templateUrl: './modal-other-kp-send-adjustment.component.html',
  styleUrls: ['./modal-other-kp-send-adjustment.component.sass']
})



export class ModalOtherKpSendAdjustmentComponent implements OnInit {
  spinner: NgxSpinnerService;
  http: HttpClient;
  service: OtherKpDetailService;
  params: any;
  mail = {IDAuc:undefined, AucAgreementComment:undefined };
   

  constructor(private _http: HttpClient, private _spinner: NgxSpinnerService, private _service: OtherKpDetailService) {
    this.http = _http;
    this.spinner = _spinner;
    this.service = _service;
   }

  ngOnInit() {
    
  }

  cleannField(){
    this.mail.AucAgreementComment = undefined;
  }

  onSave() {
    this.service.triggerSave().then(isHaveErrors => {
      if (!isHaveErrors) {
        this.mail.IDAuc = this.service.currentOtherKp.id;

        this.http.post<boolean>(apiServer + "/otherKp/SendMailToConfirm/", this.mail).subscribe(resp => {});
      }
      $('#modalOtherKpAdjustmentSender').modal('hide');
    })
  }
}





// WEBPACK FOOTER //
// ./src/app/modules/other-kp/component/other-kp-detail/modal-other-kp-send-adjustment/modal-other-kp-send-adjustment.component.ts